import React, { Fragment } from 'react';
import withLayout from '../withLayout';
import OfferPagination from './OfferPagination';
import { allOffersAnonQuery } from '../../apollo';
import AnonDashboardHeader from './AnonDashboardHeader';
import AnonDashboardFooter from './AnonDashboardFooter';

// grabbing/passing mostly router props
const Dashboard = (props) => (
  <Fragment>
    <AnonDashboardHeader />
    <OfferPagination query={allOffersAnonQuery} {...props} />
    <AnonDashboardFooter />
  </Fragment>
);

const DashboardWithLayout = withLayout(Dashboard);

export default DashboardWithLayout;



// WEBPACK FOOTER //
// ./src/components/Dashboard/AnonDashboard.js